import * as yup from 'yup'

export const schema = yup.object().shape({
  documentType: yup.string(),
  document: yup.string(),
  fantasyName: yup.string(),
  companyName: yup.string(),
  institutionalEmail: yup.string().trim().email(),
  url: yup.string(),
  businessCategory: yup.string(),
  monthlyBillingRange: yup.string(),
  city: yup.string(),
  state: yup.string(),
  cep: yup.string(),
  street: yup.string(),
  neighborhood: yup.string(),
  complement: yup.string(),
  name: yup.string(),
  cpf: yup.string(),
  rg: yup.string(),
  birthDate: yup.string(),
  celphone: yup.string(),
  email: yup.string().trim().email(),
  priceTableId: yup.string(),
})

export default schema
